import Alert from '../common/Alert.js';
import Button from '../common/Button.js';
import { getCurrentDevicePosition } from '../../utils/deviceLocation.js';

const HubGpsFields = ({ formData, onChange, onUseCurrent, loading = false }) => (
  <div className="col-span-2 sm:col-span-4 rounded-xl border border-blue-100 bg-blue-50/50 p-4 space-y-3">
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
      <div>
        <h4 className="font-semibold text-secondary">Attendance GPS</h4>
        <p className="text-xs text-gray-500">
          Required for the static hub QR. Staff must scan it within 150m of these coordinates.
        </p>
      </div>
      <Button type="button" variant="secondary" onClick={onUseCurrent} disabled={loading}>
        Use current GPS
      </Button>
    </div>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      <div>
        <label className="block text-xs font-medium text-secondary mb-1">Latitude</label>
        <input
          type="text"
          name="latitude"
          value={formData.latitude}
          onChange={onChange}
          placeholder="e.g. 19.0760"
          className="w-full px-3 py-2 border border-gray-300 rounded-xl text-sm"
          disabled={loading}
        />
      </div>
      <div>
        <label className="block text-xs font-medium text-secondary mb-1">Longitude</label>
        <input
          type="text"
          name="longitude"
          value={formData.longitude}
          onChange={onChange}
          placeholder="e.g. 72.8777"
          className="w-full px-3 py-2 border border-gray-300 rounded-xl text-sm"
          disabled={loading}
        />
      </div>
    </div>
  </div>
);

export const fillCurrentGps = async (onFilled) => {
  Alert.info('Getting current location...');
  try {
    const coords = await getCurrentDevicePosition();
    onFilled({
      latitude: String(Number(coords.latitude).toFixed(8)),
      longitude: String(Number(coords.longitude).toFixed(8)),
    });
    Alert.success('GPS coordinates filled');
  } catch (err) {
    Alert.error(err.message || 'Please allow location access to set hub GPS');
  }
};

export default HubGpsFields;
